import { store, observable, action, loadingState } from '~/common/mobx.decorator'
import { notifyStore } from '~/stores'
import axios from 'axios'
import { transformKeys } from '~/common/helpers'

@store()
class CityFieldStore {
	@observable options = []
	@observable inputValue = ''
	@observable loading = loadingState('cityFieldStore/fetchCities')
	@observable fetchDone = false

	@action
	setOptions = (options) => {
		this.options = options
	}

	@action
	fetchCities = async (input = '') => {
		try {
			const response = await axios.get(`/api/public/v1/cities?name=${input}`)
			const cities = response?.data
			const mapped = cities.map((city) => transformKeys(city))
			this.setOptions(mapped)
			this.fetchDone = true
		} catch (e) {
			this.fetchDone = true
			void notifyStore.error(e?.message || "Couldn't fetch cities", {})
		}
	}
}

const cityFieldStore = new CityFieldStore()

export default cityFieldStore
